import { Client, AwayEvent, BackEvent } from 'irc-framework';
import { IRC_EVENT, IRCMessageType } from '#/types/types';
import ConnectionHandler from '#/connectionHandler';
import TabManager from '#/ui/tabManager';
import MessageHandler from '#/messageHandler';

export class AwayEventListener {
    private cH: ConnectionHandler;
    private client: Client;
    private tM: TabManager;
    private mH: MessageHandler;

    constructor(connectionHandler: ConnectionHandler) {
        this.cH = connectionHandler as ConnectionHandler;
        this.client = connectionHandler.client as Client;
        this.tM = connectionHandler.tabManager as TabManager;
        this.mH = connectionHandler.messageHandler as MessageHandler;
        this.setup();
    }

    private setup(): void {
        this.client.on(IRC_EVENT.AWAY, (event: AwayEvent) => {
            const { self, nick, ident, hostname, message, time, account } = event;
            this.mH.addMessage(this.tM.getStatusTab(),
                            `[Unhandled] ${IRC_EVENT.AWAY}: ${JSON.stringify(event)}`, IRCMessageType.ERROR);

        });

        this.client.on(IRC_EVENT.BACK, (event: BackEvent) => {
            const { self, nick, ident, hostname, message, time, account } = event;
            this.mH.addMessage(this.tM.getStatusTab(),
                            `[Unhandled] ${IRC_EVENT.BACK}: ${JSON.stringify(event)}`, IRCMessageType.ERROR);

        });
    }
}